export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const INSIGHTS_API_BASE_URL = process.env.REACT_APP_INSIGHTS_API_URL;
export const API_BASE_URL_STRIPE = process.env.REACT_APP_API_STRIPE_URL;
export const STRIPE_API_KEY = process.env.REACT_APP_API_STRIPE_API_KEY;
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;
export const TENOR_API_KEY = process.env.REACT_APP_TENOR_API_KEY;
export const WIDGET_JS_API_URL = process.env.REACT_APP_WIDGET_JS_API_URL;
